import gql from 'graphql-tag';

const FRAGMENT_SAVED_DOCUMENT_ANCHOR = gql`
  fragment SavedDocumentAnchorFields on SavedDocumentAnchor {
    quote
    prefix
    suffix
    paragraphIndex
    occurrence
  }
`;

export const FRAGMENT_SAVED_DOCUMENT = gql`
  fragment SavedDocumentFields on SavedDocument {
    threads {
      id
      createdAt
      anchor {
        ...SavedDocumentAnchorFields
      }
      comments {
        id
        text
        createdAt
        editedAt
        canEdit
        canDelete
        author {
          id
          name
        }
      }
    }
    textRatings {
      id
      value
      createdAt
      anchor {
        ...SavedDocumentAnchorFields
      }
      author {
        id
        name
      }
    }
  }
  ${FRAGMENT_SAVED_DOCUMENT_ANCHOR}
`;
